import { delay } from "../../../AsyncUtils";
import { PicklistDataItem } from "../../../../Engine/src/Engine/Core/Picklists/PicklistTypes";
import { reject } from "../../../TypingUtils";
import { IDigestApiClient } from "../IDigestApiClient";
import { DigestRequest } from "../Types/DigestRequest";
import { IterUtils } from "../../../IterableUtils";
import { buildFilterPredicate } from "../../../../Engine/src/Engine/Core/Picklists/GPathFilter";
import { PicklistResultV2 } from "../../../PicklistApiClient/Types/PicklistResultV2";

export class FakeDigestApiClient implements IDigestApiClient {
    private readonly picklists = new Map<string, PicklistDataItem[]>();

    public constructor(picklists: Array<[string, PicklistDataItem[]]> = []) {
        this.picklists = new Map(picklists);
    }

    public createPicklist(gId: string, data: PicklistDataItem[]): void {
        this.picklists.set(gId, data);
    }

    public async getDigest(request: DigestRequest): Promise<PicklistResultV2> {
        await delay(0);
        const items = this.picklists.get(request.gId) ?? reject(`Picklist with ${request.gId} not found`);

        const columns = [
            ...IterUtils.distinctBy(
                Iterator.from(items).flatMap(x => Object.keys(x)),
                x => x
            ),
        ];
        const suitableItems = items
            .filter(buildFilterPredicate(request.filter?.filter))
            .slice(request.filter?.skip ?? 0, (request.filter?.skip ?? 0) + (request.filter?.take ?? Infinity));

        const emptyData: string[][] = [];
        return {
            data: suitableItems.reduce((acc, item) => {
                acc.push(item as never);
                return acc;
            }, emptyData),
            meta: {
                suitableCount: suitableItems.length,
                columns: columns.map(x => ({ name: x, withMarkdown: false })),
            },
        };
    }
}
